import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import {
  fetchLowStockItems,
  FetchLowStockItemsParams,
} from '@/renderer/services/inventoryDashboardService';

export function useInventoryLowStockItems(params: FetchLowStockItemsParams) {
  return useQuery({
    queryKey: queryKeys.inventory.lowStockItemsList(params),
    queryFn: async () => {
      const result = await fetchLowStockItems(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch low-stock items');
      }
      return result.data;
    },
    enabled: !!params.companyId,
    placeholderData: keepPreviousData,
  });
}
